import React from 'react';
import Info from '../Symbols/Info';
import Row from '../Symbols/Row';
import Input from '../Symbols/Input';
import InputCurrency from '../Symbols/InputCurrency';
import InputSelect from '../Symbols/InputSelect';
import Button from '../Symbols/Button';
import Result from './Result';
import Form from '../Symbols/Form';
import Wrapper from '../Symbols/Wrapper';
import { childrenOptions } from './Options';
// import { YEARS } from '../LegalParameters/Constants';

const YEARS = ['2020', '2019', '2018'];	// remove (and uncomment ^) after adding "2020" to all calculators
const years = YEARS.map(year => ({ name: year, value: year }));

const emptyFunc = () => {};

export default props => {
	const {
		validateHandler = emptyFunc,
		changeHandler = emptyFunc,
		errors = {},
		state: { income, children, length, subsidy, year },
		result = null,
		onSubmit,
		reset,
	} = props;

	return (
		<Wrapper>
			<Form onSubmit={onSubmit} title="Kalkulačka rodičovský příspěvek 2020">
				<InputSelect
					label="Výpočet pro rok:"
					name="years"
					value={year}
					onChange={changeHandler('year')}
					onBlur={validateHandler('year')}
					passedProps={{ 'data-cy': 'year' }}
					select={years}
					error={errors.year}
				/>

				<InputCurrency
					label={
						<>
							Vyměřovací základ <sup>1</sup>
						</>
					}
					name="income"
					value={income}
					onChange={changeHandler('income')}
					onBlur={validateHandler('income')}
					passedProps={{ min: 0, step: 1, 'data-cy': 'income' }}
					error={errors.income}
				/>

				<InputSelect
					label="Počet narozených dětí"
					name="children"
					value={children}
					onChange={changeHandler('children')}
					onBlur={validateHandler('children')}
					passedProps={{ 'data-cy': 'children' }}
					select={childrenOptions}
					error={errors.children}
				/>

				<Input
					label="Délka RP (počet měsíců)"
					name="length"
					value={length}
					type="number"
					onChange={changeHandler('length')}
					onBlur={validateHandler('length')}
					passedProps={{ min: 1, step: 1, max: 43, 'data-cy': 'length' }}
					error={errors.length}
				/>

				<InputCurrency
					label="Jaká výše RP by se vám hodila?"
					name="subsidy"
					value={subsidy}
					onChange={changeHandler('subsidy')}
					onBlur={validateHandler('subsidy')}
					passedProps={{ min: 1, step: 1, 'data-cy': 'subsidy' }}
					error={errors.subsidy}
				/>

				<div css={Row}>
					<Button data-cy="submit">Výpočet</Button>
				</div>

				{result && <Result rodicovska={result} />}
				{result && (
					<div css={Row}>
						<Button onClick={reset} data-cy="reset">
							Nový výpočet
						</Button>
					</div>
				)}

				<Info css={Row}>
					<p>
						<sup>1</sup> Vyměřovací základ je průměr hrubých příjmů v rozhodném období (zpravidla za
						posledních 12 měsíců).
					</p>
				</Info>
			</Form>
		</Wrapper>
	);
};
